const NAMESPACE = "createRelatedProjectDialog";

const KEYS = {
    selectConnectionLabel: "selectConnectionLabel",
    createFromSingleConnectionText: "createFromSingleConnectionText"
};

const MESSAGES = {
    [KEYS.selectConnectionLabel]: {
        value: "Create a related project using this channel:",
        comment:
            "Label for the selector that allows the user to choose what connection to use when creating a related project"
    },
    [KEYS.createFromSingleConnectionText]: {
        value: "This will create a related project using this channel: {channelName}. Do you want to continue?",
        comment:
            "Info text that displays when there is only a single channel available to create a related project which tells the user the name of the channel and asks them to confirm."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
